export default function formatPhoneNumber(number: string): string {
  const koreaRegex = /^010\d{8}$/;
  const taiwanRegex = /^09\d{8}$/;
  const hongKongRegex = /^(?:(?:852|853))?\d{8}$/;
  const chinaRegex = /^(?:86)?1\d{10}$/;
  const japanRegex = /^0[6789]0\d{8}$/;

  if (taiwanRegex.test(number))
    return `${number.slice(0, 4)}-xxx-xx${number.slice(9, 10)}`;

  if (koreaRegex.test(number))
    return `${number.slice(0, 3)}-${number.slice(3, 4)}xxx-${number.slice(7, 8)}xxx`;

  if (japanRegex.test(number))
    return `${number.slice(0, 3)}-xxxx-${number.slice(7)}`;

  if (hongKongRegex.test(number)) {
    const localNumber = number.length === 11 ? number.slice(3) : number;

    return `${localNumber.slice(0, 4)}-${localNumber.slice(4)}`;
  }

  if (chinaRegex.test(number)) {
    const localNumber = number.length === 13 ? number.slice(2) : number;

    return `${localNumber.slice(0, 3)}-${localNumber.slice(3, 7)}-${localNumber.slice(7)}`;
  }

  return "Invalid number";
}
